// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__27Kdl","col":"Table_col__2wzDM","fulfillmentStatus":"Table_fulfillmentStatus__2tkr3","emailCol":"Table_emailCol__2Uu5o"};